
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAllCities, getCitiesByCountry } from '@/services/city/cityService';
import { useLanguage } from '@/contexts/LanguageContext';

export const CityDirectory = () => {
  const [germanCities, setGermanCities] = useState<{ city: string; country: string }[]>([]);
  const [austrianCities, setAustrianCities] = useState<{ city: string; country: string }[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    const loadCities = async () => {
      setIsLoading(true);
      try {
        const allCities = await fetchAllCities();
        
        // Filter cities by country
        setGermanCities(getCitiesByCountry(allCities, 'Germany'));
        setAustrianCities(getCitiesByCountry(allCities, 'Austria'));
      } catch (error) {
        console.error('Error loading cities:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadCities();
  }, []);

  const handleCityClick = (city: string, country: string) => {
    // Force a clean new search by adding a timestamp to prevent caching
    const timestamp = new Date().getTime();
    navigate(`/search?city=${encodeURIComponent(city)}&country=${encodeURIComponent(country)}&ts=${timestamp}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (isLoading) {
    return <div className="mt-8 text-center text-gray-500">{t('loadingCities')}</div>;
  }

  return (
    <div className="mt-16 border-t border-gray-200 pt-10">
      <div className="container mx-auto px-4">
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">
            Hundeschulen in Deutschland
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
            {germanCities.map((cityData, index) => (
              <button
                key={`de-${index}`}
                onClick={() => handleCityClick(cityData.city, 'Germany')}
                className="text-sm text-left text-gray-600 hover:text-primary transition-colors"
              >
                Hundeschulen und Hundetrainer {cityData.city}
              </button>
            ))}
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">
            Hundeschulen in Österreich
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
            {austrianCities.map((cityData, index) => (
              <button
                key={`at-${index}`}
                onClick={() => handleCityClick(cityData.city, 'Austria')}
                className="text-sm text-left text-gray-600 hover:text-primary transition-colors"
              >
                Hundeschulen und Hundetrainer {cityData.city}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
